import script from "./NewLicationArea.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLicationArea.vue?vue&type=script&setup=true&lang=js"

import "./NewLicationArea.vue?vue&type=style&index=0&id=709ea6ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709ea6ce"]])

export default __exports__